module.exports = __webpack_public_path__ + "media/3dmaxplugin1.952b2abb.mp4";